import nav from "../../components/nav/Nav";
import login from "../../components/login/Login";
import favIcon from "./media/favicon.ico";
import routes from "./routes";

export default () => ({
  props: {
    DocumentTitle: {
      titleTemplate: "LenderClose Marketplace | %s",
      defaultTitle: "LenderClose Marketplace",
      favIcon
    },

    LcApp: {
      disableReCaptcha: true,
      reCaptchaSiteKey: "6Lf8Wq4UAAAAAGjl8aMAIJlVpAYaTcYV6ulVc5be",
      nav,
      login,
      routes
    },
    LcAuthProvider: {
      alwaysAuth: false,
      auth: "bearer-token",
      ping: "hello",
      register: "app/users",
      passwordReset: "password-reset",
      passwordResetCallback: "/change-pass",
      passwordResetToken: "password-reset/token",
      logoutUrl: "/logout",
      idleTimeoutMs: 60000000
    }
  }
});
